import { Component, EventEmitter, Input, Output } from '@angular/core';
import { PublicInquiryManagerService } from 'projects/webapp/app/services/public-inquiry-manager.service';

/**
 * "Zurück" / "Weiter" under every form step, with "Schritt X von Y". On the
 * last step the primary button reads "Anfrage absenden".
 */
@Component({
  selector: 'app-inquiry-step-nav',
  templateUrl: './inquiry-step-nav.component.html',
})
export class InquiryStepNavComponent {
  /** Disables the primary button, e.g. while the inquiry is being sent. */
  @Input() busy = false;

  @Output() back = new EventEmitter<void>();
  @Output() next = new EventEmitter<void>();

  constructor(protected _publicInquiryManagerService: PublicInquiryManagerService) {
  }

  get stepCount() {
    return this._publicInquiryManagerService.flowSteps().length;
  }

  get stepNumber() {
    return this._currentIndex() + 1;
  }

  get isLastStep() {
    const count = this.stepCount;
    return count > 0 && this._currentIndex() === count - 1;
  }

  protected _currentIndex() {
    const currentStep = this._publicInquiryManagerService.inquiryCreationProgress?.currentStep;
    return this._publicInquiryManagerService.flowSteps().findIndex(s => s.step === currentStep);
  }
}
